import React, { useState } from 'react'
import { Alert, Typography, Link } from '@mui/material'
import InfoNotification from '../images/notificationInfo'
import PropTypes from 'prop-types'
import PriceComparisonDialog from './PriceComparisonDialog'
import { pdsAnalytics } from 'analytics/pdsAnalytics'
import { usePriceComparisonChanges } from 'hooks/usePriceComparisonChanges'
import { useTranslation } from 'react-i18next'
import { IS_NEW_LAYOUT_ENABLED } from 'constants/layoutConstant'
import OldPriceComparisonDialog from './OldPriceComparisonDialog'

const PDSInfo = ({
    priceData,
    bannerMessage,
    isViewChangesEnabled,
    dealerName,
    dealerPhoneNumber,
    transactionType
}) => {
    const { t } = useTranslation()

    const { totalChanges } = usePriceComparisonChanges(priceData)
    const eventValues = {
        linkType: 'cta:modal',
        contentSubType: 'pds modal',
        sateliteTrackId: 'ecommInternalCtaClick'
    }

    const [openDialog, setOpenDialog] = useState(false)

    const showDialog = () => {
        pdsAnalytics.clickEvent('banner view changes:' + totalChanges, eventValues)
        setOpenDialog(true)
    }

    const closeDialog = () => {
        setOpenDialog(false)
    }

    return (
        <Typography variant="smallHeadline2" data-testid="pre-delivery-summary-notification">
            <Alert
                severity="warning"
                icon={<InfoNotification />}
                tabIndex={0}
                sx={
                    IS_NEW_LAYOUT_ENABLED
                        ? {
                              borderRadius: 0,
                              backgroundColor: '#FCF2E6',
                              mx: { xs: 3, md: 0 }
                          }
                        : {
                              borderStyle: 'solid',
                              borderColor: 'common.alert.info',
                              borderWidth: '1px 1px 1px 8px',
                              borderRadius: 2
                          }
                }
            >
                <Typography
                    variant={IS_NEW_LAYOUT_ENABLED ? 'boldBody1' : 'regularBody1'}
                    sx={{ color: 'common.neutralBlack.dark' }}
                    data-test-id="banner-change"
                    className="banner_info_details"
                >
                    {bannerMessage}
                    {isViewChangesEnabled && (
                        <Typography
                            sx={
                                IS_NEW_LAYOUT_ENABLED
                                    ? {
                                          marginLeft: '5px',
                                          fontWeight: 700,
                                          display: 'inline',
                                          fontSize: '16px'
                                      }
                                    : { marginLeft: '0px', fontSize: '16px' }
                            }
                        >
                            <Link
                                component="button"
                                tabIndex={0}
                                color={IS_NEW_LAYOUT_ENABLED ? 'common.link.light' : 'common.link.main'}
                                onClick={showDialog}
                                sx={IS_NEW_LAYOUT_ENABLED ? { marginTop: '1px' } : { marginTop: '0px' }}
                            >
                                {t('view_changes')}
                            </Link>
                            {openDialog && IS_NEW_LAYOUT_ENABLED && (
                                <PriceComparisonDialog
                                    priceData={priceData}
                                    dealerName={dealerName}
                                    dealerPhoneNumber={dealerPhoneNumber}
                                    transactionType={transactionType}
                                    isDialogOpen={openDialog}
                                    closeDialog={closeDialog}
                                />
                            )}
                            {openDialog && !IS_NEW_LAYOUT_ENABLED && (
                                <OldPriceComparisonDialog
                                    priceData={priceData}
                                    isDialogOpen={openDialog}
                                    closeDialog={closeDialog}
                                />
                            )}
                        </Typography>
                    )}
                </Typography>
            </Alert>
        </Typography>
    )
}

PDSInfo.propTypes = {
    bannerMessage: PropTypes.string,
    isViewChangesEnabled: PropTypes.bool,
    priceData: PropTypes.object,
    dealerName: PropTypes.string,
    dealerPhoneNumber: PropTypes.string,
    transactionType: PropTypes.string
}

export default PDSInfo
